import React from 'react';
import { allFaqs } from '../data/faqs';
const SITE_URL = 'https://www.californiamesotheliomaclaims.com';
const FIRM_NAME = 'California Mesothelioma Claims';
const PHONE = '+1-805-770-9317';
const EMAIL = 'help@californiamesotheliomaclaims.com';
export function SeoHead() {
  const legalServiceSchema = {
    '@context': 'https://schema.org',
    '@type': 'LegalService',
    '@id': `${SITE_URL}/#organization`,
    name: FIRM_NAME,
    alternateName: 'California Mesothelioma Claims Law Group',
    description: 'California Mesothelioma Claims is a California law firm dedicated exclusively to mesothelioma and asbestos litigation, recovering over $2 billion for asbestos victims and their families statewide.',
    url: SITE_URL,
    telephone: PHONE,
    email: EMAIL,
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Los Angeles',
      addressRegion: 'CA',
      addressCountry: 'US'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 34.0522,
      longitude: -118.2437
    },
    areaServed: {
      '@type': 'State',
      name: 'California'
    },
    knowsAbout: ['Mesothelioma litigation', 'Asbestos exposure claims', 'Asbestos trust fund claims', 'Wrongful death lawsuits', 'California asbestos exposure sites'],
    priceRange: 'Contingency fee — no win, no fee',
    openingHours: 'Mo-Su 00:00-23:59'
  };
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    url: SITE_URL,
    name: FIRM_NAME,
    publisher: {
      '@id': `${SITE_URL}/#organization`
    },
    inLanguage: 'en-US'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    '@id': `${SITE_URL}/#faq`,
    mainEntity: allFaqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer
      }
    }))
  };
  return <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(legalServiceSchema)
    }} data-id="element-275" data-mp="1c2551vvzp4yd" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(websiteSchema)
    }} data-id="element-276" data-mp="1h29jzhh91rmh" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema)
    }} data-id="element-277" data-mp="1l4xv5vtframm" />
    </>;
}